import { matchPath } from 'react-router';

import { PageTags, Params } from './types';

class HomePageTags extends PageTags {
  static get({ pathname, exact }: Params) {
    let currentPage = '';
    // eslint-disable-next-line no-restricted-syntax
    for (const [path] of Object.entries(this.container)) {
      const currentRoutePath = matchPath(pathname, { path, exact });
      if (currentRoutePath) {
        currentPage = path;
        break;
      }
    }

    if (this.container[currentPage]) {
      return this.container[currentPage];
    }
    return undefined;
  }

  static get container(): {[key: string]: string[]} {
    return {
      '/dashboard/home': this.home,
    };
  }

  static get home() {
    return [
      'tag:getting-started',
      'tag:dashboard',
      'tag:release-notes',
    ];
  }
}


export default HomePageTags;
